/**
 * Langue de l’interface de réservation Cal : `lng=fr` sur l’URL (libellés type « Nom », « Adresse e-mail », etc.).
 *
 * Les questions personnalisées du formulaire (« Aujourd’hui… », « Additional notes », etc.) ne sont pas
 * pilotables depuis le code : les modifier dans Cal.com → Événements → cet événement (45 min) →
 * « Questions » / workflow de réservation : une seule question longue libellée
 * « Message (dispos, besoins…) » (ou supprimer les champs inutiles).
 */
export const CAL_DEMO_BOOKING_URL =
  'https://cal.com/jean-treins-education-x13lqv/45min?lng=fr';

/** Lien passé au composant embed (`calLink`, sans domaine, avec query). */
export const CAL_EMBED_LINK = 'jean-treins-education-x13lqv/45min?lng=fr';

/** Doit correspondre à `namespace` du composant `<Cal />` et à `getCalApi({ namespace })`. */
export const CAL_EMBED_NAMESPACE = '45min';

export type DemoBookingPrefill = {
  name?: string;
  email?: string;
};

export function buildDemoBookingUrl(prefill?: DemoBookingPrefill): string {
  const url = new URL(CAL_DEMO_BOOKING_URL);
  const email = prefill?.email?.trim();
  const name = prefill?.name?.trim();
  if (email) url.searchParams.set('email', email);
  if (name) url.searchParams.set('name', name);
  return url.toString();
}
